import { CSSProperties, useState } from 'react';
import { Stack } from '@mui/material';
import {
  CasMRTCellRenderDate,
  CasMRTable,
  CasMRTCellRenderDecimal,
  CasErrorDisplay,
} from 'src/compass/shared/components';
import LrpQuotesFooter from './LrpQuotesFooter';
import LrpTypeSelector from './LrpTypeSelector';

type LrpQuotesTabProps = {
  tabData: any;
  baseColor: string;
  buttonColor?: string;
  subTitle?: string;
};

export default function LrpQuotesTab({ tabData, baseColor, buttonColor, subTitle }: LrpQuotesTabProps) {
  const [selectedType, setSelectedType] = useState(tabData?.types?.[0]);

  const columns = [
    { accessorKey: 'endDate', header: 'End Date', Cell: CasMRTCellRenderDate },
    { accessorKey: 'coveragePrice', header: 'Floor Price', Cell: CasMRTCellRenderDecimal },
    { accessorKey: 'costPerCwtAmount', header: 'Cost Cwt', Cell: CasMRTCellRenderDecimal },
  ];

  if (!tabData) return <CasErrorDisplay message="No active quotes" sx={{ textAlign: 'center' }} />;

  const colorStyle: CSSProperties = {
    ['--tab-color' as any]: baseColor,
    ['--tab-button-color' as any]: buttonColor || baseColor,
  };

  return (
    <Stack my={1} sx={{ textAlign: 'center' }} style={colorStyle}>
      <LrpTypeSelector
        subTitle={subTitle}
        types={tabData.types}
        selectedType={selectedType}
        onTypeChange={setSelectedType}
      />
      <CasMRTable
        data={selectedType?.levels || []}
        columns={columns}
        enableExpanding
        enableTopToolbar={false}
        enablePagination={false}
        enableSorting={false}
      />

      <LrpQuotesFooter />
    </Stack>
  );
}
